import {
  axiosAdminPrivate,
  axiosAdminPublic,
} from "@shared/api/base/adminAxiosApi";
import { API_PATHS } from "@shared/api/constants";

export const authAdmin = async (payload) => {
  return axiosAdminPublic.post(API_PATHS.ADMIN_AUTH, payload);
};

export const adminStatistics = async () =>
  await axiosAdminPrivate.get(API_PATHS.ADMIN_MAIN_STATS);

//USER

export const adminUserList = async (params) =>
  await axiosAdminPrivate.get(API_PATHS.ADMIN_USERS_LIST, { params });

export const adminUserInfo = async (id) =>
  await axiosAdminPrivate.get(`${API_PATHS.ADMIN_USERS_LIST}/${id}`);

export const adminUserEdit = async (id, payload) =>
  await axiosAdminPrivate.patch(`${API_PATHS.ADMIN_USERS_LIST}/${id}`, payload);

export const adminUserPackageEdit = async (id, payload) =>
  await axiosAdminPrivate.post(
    `${API_PATHS.ADMIN_USERS_LIST}/${id}/update_subscription/`,
    payload,
  );

export const adminUserDelete = async (id) =>
  await axiosAdminPrivate.delete(`${API_PATHS.ADMIN_USERS_LIST}/${id}`);

export const adminUserActivate = async (id) =>
  await axiosAdminPrivate.post(
    `${API_PATHS.ADMIN_USERS_LIST}/${id}/activate_user/`,
  );

export const adminUserBlock = async (id) =>
  await axiosAdminPrivate.post(
    `${API_PATHS.ADMIN_USERS_LIST}/${id}/block_user/`,
  );

//ASSISTANTS

export const adminAssistantsInfo = async (params) =>
  await axiosAdminPrivate.get(`${API_PATHS.ADMIN_ASSISTANTS_LIST}`, { params });

export const adminAssistantInfo = async (id) =>
  await axiosAdminPrivate.get(`${API_PATHS.ADMIN_ASSISTANTS_LIST}/${id}`);

export const adminAssistantBlock = async (payload) =>
  await axiosAdminPrivate.post(`notifications/block_resource/`, payload);

export const adminAssistantDeactivate = async (id) =>
  await axiosAdminPrivate.post(
    `${API_PATHS.ADMIN_ASSISTANTS_LIST}/${id}/deactivate/`,
  );

export const adminAssistantActivate = async (id) =>
  await axiosAdminPrivate.post(
    `${API_PATHS.ADMIN_ASSISTANTS_LIST}/${id}/activate/`,
  );

//PACKAGES

export const adminPackagesInfo = async () =>
  await axiosAdminPrivate.get(`${API_PATHS.ADMIN_SUBSCRIPTION_LIST}`);

export const adminGetPackage = async (id) =>
  await axiosAdminPrivate.get(`${API_PATHS.ADMIN_SUBSCRIPTION_LIST}/${id}`);

export const adminDeletePackage = async (id) =>
  await axiosAdminPrivate.delete(`${API_PATHS.ADMIN_SUBSCRIPTION_LIST}/${id}`);

export const adminEditPackage = async (id, payload) =>
  await axiosAdminPrivate.patch(
    `${API_PATHS.ADMIN_SUBSCRIPTION_LIST}/${id}`,
    payload,
  );

export const adminCreatePackage = async (payload) =>
  await axiosAdminPrivate.post(
    `${API_PATHS.ADMIN_SUBSCRIPTION_LIST}/`,
    payload,
  );

//PAYMENTS

export const adminPaymentsInfo = async (params) =>
  await axiosAdminPrivate.get(`${API_PATHS.PAYMENTS}`, {
    params,
  });

//EXPORT FILES

export const adminGetUsersFile = async () =>
  await axiosAdminPrivate.get(`${API_PATHS.EXPORT_USERS_DATA}`, {
    responseType: "blob",
  });

export const adminGetPaymentsFile = async () =>
  await axiosAdminPrivate.get(`${API_PATHS.EXPORT_PAYMENTS_DATA}`, {
    responseType: "blob",
  });

export const adminGetAssistantsFile = async () =>
  await axiosAdminPrivate.get(`${API_PATHS.EXPORT_ASSISTANTS_DATA}`, {
    responseType: "blob",
  });

// NEWS

export const adminNewsList = async () =>
  await axiosAdminPrivate.get(`${API_PATHS.ADMIN_NOTIFICATIONS_LIST}`);

export const adminCreateNews = async (payload) =>
  await axiosAdminPrivate.post(
    `${API_PATHS.ADMIN_NOTIFICATIONS_LIST}/`,
    payload,
    { headers: { "Content-Type": "multipart/form-data" } },
  );

export const adminDeleteNews = async (params) =>
  await axiosAdminPrivate.delete(
    `${API_PATHS.ADMIN_NOTIFICATIONS_LIST}/delete_global/`,
    { params },
  );

// REWARDS

export const adminRewardsList = async () =>
  await axiosAdminPrivate.get(API_PATHS.ADMIN_REWARDS);

export const adminRewardsDelete = async (id) =>
  await axiosAdminPrivate.delete(`${API_PATHS.ADMIN_REWARDS}/${id}`);

export const adminRewardsUpdate = async (id, payload) =>
  await axiosAdminPrivate.patch(`${API_PATHS.ADMIN_REWARDS}/${id}`, payload);

export const adminRewardsCreate = async (payload) =>
  await axiosAdminPrivate.post(`${API_PATHS.ADMIN_REWARDS}/`, payload);

// INTEGRATIONS

export const adminIntegrationsList = async (params) =>
  await axiosAdminPrivate.get(API_PATHS.ADMIN_INTEGRATIONS, { params });

export const adminIntegrationDetail = async (id) =>
  await axiosAdminPrivate.get(`${API_PATHS.ADMIN_INTEGRATIONS}${id}`);

// TICKETS

export const adminTicketsList = async (params) =>
  await axiosAdminPrivate.get(`${API_PATHS.ADMIN_TICKET_LIST}`, { params });

export const adminGetTicket = async (id) =>
  await axiosAdminPrivate.get(`${API_PATHS.ADMIN_TICKET_LIST}/${id}`);

export const adminReplyTicket = async (id, data) =>
  await axiosAdminPrivate.post(
    `${API_PATHS.ADMIN_TICKET_LIST}/${id}/reply/`,
    data,
  );

export const adminSolveTicket = async (id) =>
  await axiosAdminPrivate.post(`${API_PATHS.ADMIN_TICKET_LIST}/${id}/solve/`);
